export class Response_User_Logout {
  public return_url: string;
}
